import { PayloadAction } from '@reduxjs/toolkit';
import { service_socketio_client } from '../../../services/socketio_client_react/service_socketio_client';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateUser } from '../state_user';

export const LOCAL__user_auth_logout = (_: string = ''): PayloadAction<string> => ({
  type: ENUM__redux_action.USER_AUTH_LOGOUT,
  payload: _,
});

export const INIT_LOCAL__user_auth_logout = (state: StateUser, action: PayloadAction<string>) => {
  state.auth_token = '';
  service_socketio_client.is_connection_authorized = false;
};
